import React from 'react'
import NestedPageHero from '../NestedPageHero';

import '../../style/About.css';
import WelcomeSection from '../WelcomeSection';
import StatsSection from '../StatsSection';
import TestimonialsSection from '../TestimonialsSection';
import FAQs from '../FAQs';

const About = () => {
  return (
    <div className='pt-4'>
      <NestedPageHero title={'About Us'} />
      <WelcomeSection/>
      <StatsSection/>
      <TestimonialsSection/>
      <FAQs />
    </div>
  )
}

export default About